<template>
    <header>
        <div class="title">
            <div>
                <router-link to="/"
                    ><span
                        class="brown d-none d-sm-inline"
                        style="font-size: 20px;"
                        ><i>Just use</i></span
                    ><span
                        class="text-secondary"
                        style="font-size: 75px; font-family: sans-serif;"
                        ><b>VPN<i>la</i></b></span
                    ><span
                        class="brown d-none d-sm-inline"
                        style="font-size: 75px; font-weight: 100;"
                        >~</span
                    ></router-link
                >
            </div>
            <div class="d-none d-lg-block">
                <b-row v-if="loggedIn && user.plan">
                    <b-col>
                        <b-card
                            bg-variant="dark"
                            text-variant="light"
                            class="p-1 px-3 dense nowrap"
                            no-body
                        >
                            <p>Plan: {{ user.plan.nickname }}</p>
                            <p>
                                Status:
                                <b-badge
                                    :variant="user.enabled ? 'success' : 'danger'"
                                >
                                    {{ user.enabled ? 'Active' : 'Deactivated' }}
                                </b-badge>
                            </p>
                            <p>
                                Data remaining:
                                <span v-if="user.plan.dataCap">{{
                                    (user.plan.dataCap - user.upload - user.download)
                                    | formatData
                                }}</span>
                                <span v-else>∞</span>
                            </p>
                            <p>
                                Time remaining:
                                <span v-if="user.plan.timeCap">{{
                                    (user.plan.timeCap - user.timeUsed) 
                                    | formatMinute
                                }}</span>
                                <span v-else>∞</span>
                            </p>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card
                            bg-variant="dark"
                            text-variant="light"
                            class="p-1 px-3 dense nowrap"
                            no-body
                        >
                            <p>
                                Account:
                                {{ (user.balance + user.credit) | formatCurrency }}
                            </p>
                            <p>
                                Bill: {{ user.bill | formatCurrency }}
                                {{ (parseInt(user.lastBilled) +
                            parseInt(user.plan.billingInterval) * 60000)
                            | formatTimeDistance }}
                            </p>
                            <p>
                                {{user.download | formatData}} ⮃
                                {{ user.upload | formatData }}
                            </p>
                            <p>{{ user.timeUsed | formatMinute }} used</p>
                        </b-card>
                    </b-col>
                </b-row>
                <b-button-group v-else>
                    <b-button variant="primary" to="/login">Login</b-button>
                    <b-button variant="secondary" to="/register"
                        >Register</b-button
                    >
                </b-button-group>
            </div>
        </div>
    </header>
</template>

<script>
    import Cookies from 'js-cookie'
    import { mapState } from 'vuex'

    export default {
        computed: {
            loggedIn() {
                return !!Cookies.get('auth')
            },
            ...mapState({
                user: state => state.user.user.user
            })
        },
        created() {
            if (this.loggedIn) this.$store.dispatch('user/user/load')
        }
    }
</script>

<style scoped>
    .title {
        position: relative;
        height: auto;
        overflow: hidden;
        background-color: var(--darkbrown);
        padding: 0 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .title a:hover {
        color: transparent;
    }
</style>